'use strict';

var createStore = require('./createStore');
var applyMiddleware = require('./utils/applyMiddleware');
var combineReducers = require('./utils/combineReducers');

module.exports = {
  createStore: createStore.createStore,
  applyMiddleware: applyMiddleware,
  combineReducers: combineReducers
};
